import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, vModelText as _vModelText } from "vue"
import _imports_0 from '@/img/exclamation.svg'


const _hoisted_1 = { class: "opModal" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = ["value"]
const _hoisted_5 = {
  key: 0,
  class: "body"
}
const _hoisted_6 = {
  class: "table table-striped",
  style: {"min-width":"720px"}
}
const _hoisted_7 = { class: "text-end" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { style: {"vertical-align":"middle"} }
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onUpdate:modelValue"]
const _hoisted_13 = ["onUpdate:modelValue"]
const _hoisted_14 = {
  class: "text-end",
  style: {"vertical-align":"middle"}
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "mt-5 text-center mw-700" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_op_date = _resolveComponent("op-date")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", null, [
        _createVNode(_component_localized_text, {
          localizedKey: "Includi orari di prenotazione all'agenda",
          text: "Includi orari di prenotazione all'agenda"
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("label", null, [
        _createVNode(_component_localized_text, {
          localizedKey: "Seleziona professione",
          text: "Seleziona professione"
        })
      ]),
      _withDirectives(_createElementVNode("select", {
        class: "form-control",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedProfessione) = $event))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.professioni, (item, i) => {
          return (_openBlock(), _createElementBlock("option", { value: item }, _toDisplayString(item.name), 9, _hoisted_4))
        }), 256))
      ], 512), [
        [_vModelSelect, _ctx.selectedProfessione]
      ])
    ]),
    _cache[6] || (_cache[6] = _createElementVNode("hr", null, null, -1)),
    (_ctx.selectedProfessione)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("table", _hoisted_6, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Giorno",
                    text: "Giorno"
                  })
                ]),
                _createElementVNode("td", null, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Fasce orarie",
                    text: "Fasce orarie"
                  })
                ]),
                _createElementVNode("td", _hoisted_7, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-success",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addInclusione && _ctx.addInclusione(...args)))
                  }, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "+ aggiungi inclusione",
                      text: "+ aggiungi inclusione"
                    })
                  ])
                ])
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inclusioni, (item, i) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item.identifier
                }, [
                  _createElementVNode("td", {
                    class: _normalizeClass({ 'bg-warning': !item.identifier })
                  }, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("label", null, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "Giorno",
                          text: "Giorno"
                        }),
                        (_ctx.isDataDuplicata(item))
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _cache[4] || (_cache[4] = _createElementVNode("img", {
                                class: "ms-2",
                                src: _imports_0
                              }, null, -1)),
                              _cache[5] || (_cache[5] = _createTextVNode(" data duplicata "))
                            ], 64))
                          : _createCommentVNode("", true),
                        (!item.identifier)
                          ? (_openBlock(), _createBlock(_component_localized_text, {
                              key: 1,
                              class: "ms-1",
                              localizedKey: "(Da salvare)",
                              text: "(Da salvare)"
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode(_component_op_date, {
                        class: "form-control",
                        modelValue: item.date,
                        "onUpdate:modelValue": ($event: any) => ((item.date) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ])
                  ], 2),
                  _createElementVNode("td", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-sm btn-success",
                        onClick: ($event: any) => (_ctx.addFascia(item))
                      }, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "Aggiungi fascia oraria",
                          text: "Aggiungi fascia oraria"
                        })
                      ], 8, _hoisted_11)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.timeTable, (ora, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "text-center",
                        key: i
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          type: "time",
                          "onUpdate:modelValue": ($event: any) => ((ora.from) = $event)
                        }, null, 8, _hoisted_12), [
                          [_vModelText, ora.from]
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          type: "time",
                          "onUpdate:modelValue": ($event: any) => ((ora.to) = $event)
                        }, null, 8, _hoisted_13), [
                          [_vModelText, ora.to]
                        ])
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("td", _hoisted_14, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-danger",
                      onClick: ($event: any) => (_ctx.removeInclusione(item))
                    }, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "- rimuovi giorno",
                        text: "- rimuovi giorno"
                      })
                    ], 8, _hoisted_15)
                  ])
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-success",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.ok && _ctx.ok(...args)))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "OK",
                text: "OK"
              })
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "ms-4 btn btn-danger",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close')))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Annulla",
                text: "Annulla"
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}